import i18n from "i18next";

export const options = {
  // fallbackLng: "en",
  saveMissingTo: "current",
  // have a common namespace used around the full app
  ns: ["translation"],
  defaultNS: "translation",
  // debug: true,
  returnEmptyString: false,
  bindI18n: false,
  interpolation: {
    escapeValue: false, // not needed for react as it escapes by default
  },
  react: {
    useSuspense: false,
  },
};

const I18Next = () => {
  i18n.init(options);

  return i18n;
};

export default I18Next;
